import { CLIENT_TYPES } from '@core/constants/client.constants'

export const CLIENT_TYPE_IDS = {
    NATIONAL_SCHOOL: 1,
    INTERNATIONAL_SCHOOL: 2,
    CORPORATE_FOUNDATION: 3,
    CORPORATE_CSR: 4,
    NGO: 5,
    GRANTS: 6,
    GOVERNMENT: 7,
    PSU: 8,
    PARENT: 9,
    DONOR: 10,
    INTERNATIONAL_VENDOR: 11,
    UNIVERSITY: 12,
    JOINT_ENTRANCE_EXAMINATION: 13,
    GROUP_SCHOOL: 14,
    MULTILATERALS: 15,
    HNI: 16,
} as const

export const CLIENT_TYPE_GROUPS = {
    SCHOOL_TYPES: [CLIENT_TYPE_IDS.NATIONAL_SCHOOL],
    SHIKSHA_TYPES: [
        CLIENT_TYPE_IDS.CORPORATE_FOUNDATION,
        CLIENT_TYPE_IDS.CORPORATE_CSR,
        CLIENT_TYPE_IDS.NGO,
        CLIENT_TYPE_IDS.GRANTS,
        CLIENT_TYPE_IDS.GOVERNMENT,
        CLIENT_TYPE_IDS.PSU,
        CLIENT_TYPE_IDS.DONOR,
        CLIENT_TYPE_IDS.MULTILATERALS,
        CLIENT_TYPE_IDS.HNI,
    ],
} as const

// Single source of truth for Shiksha funder membership, keyed off CLIENT_TYPE_GROUPS.SHIKSHA_TYPES
export const isShikshaClientType = (clientType: string | null | undefined): boolean => {
    if (!clientType) return false
    const id = CLIENT_TYPES.find((type) => type.clientType === clientType)?.id
    return id !== undefined && (CLIENT_TYPE_GROUPS.SHIKSHA_TYPES as readonly number[]).includes(id)
}

export const CLIENT_TYPE_MESSAGES = {
    DISABLED_TOOLTIP: 'You are not allowed to create this client type.',
} as const
